<template>
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" stroke-linecap="round" fill="none"
		 stroke-width="1px" stroke="white">
		
		<rect x="7.1" y="5.8" width="7.8" height="15.9" rx="1.8" ry="1.8"
			  transform="translate(5.3 -2.9) rotate(19.8)"/>
		<circle cx="12.3" cy="10.3" r="2.2"/>
		<g stroke-width="0.6px">
			<circle cx="9" cy="14.7" r=".9"/>
			<circle cx="8" cy="17.5" r=".9"/>
			<circle cx="12" cy="15.8" r=".9"/>
			<circle cx="11" cy="18.6" r=".9"/>
		</g>
		<path d="M10.7,2s5.3-2.4,8,2.9"/>
		<path d="M12.2,3.4s2.8-1.3,4.4,1.6"/>
	</svg>
</template>

<style scoped>
	svg {
		width: calc(var(--font-size-lg) * 1.4);
		filter: drop-shadow(var(--shadow-sm));
	}
</style>
